import {createAction, props} from "@ngrx/store";
import {RegisterUserDto} from "@server-models";
import {IRegisterGuestAction} from "@team/pages/register/interfaces/register-guest-action.interface";

export const initRegistrationGuest = createAction(
  '[Team Register] Registration Guest Start',
  props<{ isLoadingId: number | string, currentEmail: string | undefined }>()
);

export const initRegistrationGuestDialogOpen = createAction(
  '[Team Register] Registration Guest Dialog Open',
  props<{ currentEmail: string | undefined }>()
);

export const initRegistrationGuestDialogClose = createAction(
  '[Team Register] Registration Guest Dialog Close'
);

export const initRegistrationGuestSuccess = createAction(
  '[Team Register] Registration Guest Success'
);

export const initRegistrationGuestFail = createAction(
  '[Team Register] Registration Guest Fail',
  props<{ error: any }>()
);

export const registerGuestPinRequest = createAction(
  '[Team Register] Guest Pin Request Start',
  props<{ registerGuest: IRegisterGuestAction, isLoadingId?: number | string }>()
);

export const registerGuestPinRequestSuccess = createAction(
  '[Team Register] Guest Pin Request Success',
  props<IRegisterGuestAction>()
);

export const registerGuestPinRequestFail = createAction(
  '[Team Register] Guest Pin Request Fail',
  props<{ error: any }>()
);

export const registerGuestPinDialog = createAction(
  '[Team Register] Guest Pin Dialog Start'
);

export const registerGuestPinDialogCancel = createAction(
  '[Team Register] Guest Pin Dialog Cancel'
);

export const registerGuestAsUser = createAction(
  '[Team Register] Guest As User Start',
  props<{ data: RegisterUserDto, isLoadingId: number | string, isRetry?: boolean }>()
);

export const registerGuestAsUserSuccess = createAction(
  '[Team Register] Guest As User Success',
  props<{
    email: string;
    passwordBase64: string;
    isRetry: boolean;
  }>()
);

export const registerGuestAsUserFail = createAction(
  '[Team Register] Guest As User Fail',
  props<{ error: any }>()
);

export const checkInvitationCode = createAction(
  '[Team Register] Check Invitation Code',
  props<{ code: string, isLoadingId?: number | string }>()
);

export const checkInvitationCodeSuccess = createAction(
  '[Team Register] Check Invitation Code Success'
);

export const checkInvitationCodeFail = createAction(
  '[Team Register] Check Invitation Code Fail',
  props<{ error: any }>()
);

export const checkInvitationIdentity = createAction(
  '[Team Register] Check Invitation Identity',
  props<{ code: string, lastName: string, pin: string, isLoadingId?: string }>()
);

export const checkInvitationIdentitySuccess = createAction(
  '[Team Register] Check Invitation Identity Success',
  props<{ tenantId: number }>()
);

export const checkInvitationIdentityFail = createAction(
  '[Team Register] Check Invitation Identity Fail',
  props<{ error: any }>()
);
